import React, { useCallback } from "react";

import { Button } from "@fluentui/react-components";
import { LogCategory } from "Enumerations";
import { Paths } from "Shared/Utils";
import { observer } from "mobx-react";
import { useClassicVersionButtonStyles } from "./ClassicVersionButton.styles";
import { useLogging } from "Shared/Hooks";

const ClassicVersionButtonBase = () => {
    const classNames = useClassicVersionButtonStyles();
    const { trackEvent } = useLogging(LogCategory.Core);

    const onRedirectToV1 = useCallback(() => {
        trackEvent("ba9203f2-1d35-4a8b-8bd2-21ac6dc2095d", "Switch_Back_To_V1_From_V2_Large_Screen_App_Header");
        const currentState: unknown = window.history.state;
        window.history.pushState(currentState, "", Paths.getFullPath("/apphub/legacy"));
        window.dispatchEvent(new PopStateEvent("popstate", { state: currentState }));
    }, [trackEvent]);

    return (
        <div className={classNames.root}>
            <Button as="button" onClick={onRedirectToV1} className={classNames.button}>
                Legacy apps
            </Button>
        </div>
    );
};

export const ClassicVersionButton = observer(ClassicVersionButtonBase);
